define([
	"dojo/_base/declare",
	"underscore",
	"csi/toolbar/MultiSelectSwitchboard"
], function(declare, _, MultiSelectSwitchboard) {

	return declare(MultiSelectSwitchboard, {
		disableButtonAction: true,
		idViewProperty: "activeProductSalesRegions",
		placeHolder: "SelectOne",
		resDefault: "",
		switchboardPath: "Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions",
		hideGo: true,

		/**
		 * @override
		 * @returns true if Food has at least one ProductSalesRegions
		 */
		canShowPlugin: function() {
			const view = this.getView();
			const foodLabelRev = view.getViewNode();
			const foodNode = foodLabelRev && view.getCache().getPathNode(foodLabelRev, "Child:__Parent__/Child:__Parent__");
			const salesRegionUrls = foodNode && foodNode.ProductSalesRegions;
			return !_.isEmpty(salesRegionUrls);
		},

		/**
		 * @override
		 * do nothing - idViewProperty handles it all
		 */
		onChangeItem: function(view, node) {
		},

		/**
		 * @override
		 * Hide if printing
		 */
		validatePlugin: function(ctx) {
			if (ctx.getContextNode() == null) {
				return false;
			}
			return !ctx.bPrint;
		}
	});
});